import { useState } from 'react';
import nanoid from 'nanoid';

function useInputId(): string {
  const [id] = useState(() => nanoid(8));
  return id;
}

export default useInputId;
